import { StyleSheet, Text, View, ViewStyle } from "react-native";
import { FontAwesome5 } from "@expo/vector-icons";
import { Colors, Typography } from "../../styles";
import { Data } from "../../types";
import { Visibility } from "../../types/data";
import { entityIcon } from "../../utils/data";

const VisibilityData = ({
  entity,
  visibility,
  style,
}: {
  entity: Data.Entity;
  visibility: Visibility;
  style?: ViewStyle;
}) => {
  return (
    <View style={[styles.meta, style]}>
      <View style={styles.metaItem}>
        <Text style={styles.metaTitle}>Entity</Text>
        <FontAwesome5
          name={entityIcon(entity)}
          size={13}
          color={Colors.white}
        />
      </View>
      <View style={styles.divider} />
      <View style={styles.metaItem}>
        <Text style={styles.metaTitle}>Visibility</Text>
        <Text style={styles.metaText}>
          {visibility.data.slice(-1)[0].toFixed(0)}%
        </Text>
      </View>
      <View style={styles.metaItem}>
        <Text style={styles.metaTitle}>Target</Text>
        <Text style={styles.metaText}>
          {visibility.target !== undefined
            ? visibility.target.toFixed(0) + "%"
            : "-"}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  meta: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 15,
  },
  metaItem: {
    alignItems: "center",
    marginRight: 10,
    // height: 30,
    // justifyContent: "space-between",
  },
  metaTitle: {
    ...Typography.weightRegular,
    fontSize: 12,
    color: Colors.plum300,
    marginBottom: 5,
  },
  metaText: {
    ...Typography.paragraph,
    // fontSize: 13,
    marginTop: -3,
  },
  divider: {
    width: 1,
    height: "100%",
    backgroundColor: Colors.plum500,
    marginRight: 10,
  },
});

export default VisibilityData;
